<template>
    <div>
        <div class="element-wrapper">
          <i class="fas fa-basketball-ball"></i>
          <div class="text-utils">

          <div class="h-spacer ma10"></div>
            <table style="width:100%">
              <!-- <thead  align="center"> -->
                <tr>
                <th colspan="3" ><span class="title-bg"><h3>Entrainements</h3></span></th>
                <!-- <th colspan="3" >Entrainements</th> -->
              </tr>
              <!-- </thead> -->

              <tr v-for="(item, idx) in table_training" :key="idx">
                <td class="bop-table-cell" v-for="(row_item, row_idx) in item" :key="row_idx">{{row_item.c}}</td>
              </tr>
            </table>

          <div class="h-spacer ma30"></div>

            <table style="width:100%">
            <tr>
              <th colspan="3" ><span class="title-bg"><h3>Matchs</h3></span></th>
              <!-- <th colspan="3">Matchs</th> -->
            </tr>
            <tr v-for="(item, idx) in table_match" :key="idx">
              <!-- <td></td> -->
              <td class="bop-table-cell" colspan="3">
                {{ item[0].c }} - {{ item[1].c }}
              </td>
              <!-- <td></td> -->
              <!-- <td></td> -->
            </tr>
          </table>


          </div>
          <div class="h-spacer ma30"></div>
          <!-- <v-btn outline color="white">Voir le planning complet</v-btn> -->
      </div>
    </div>
</template>

<script>

  export default {
    data() {
      return {};
    },
    props: {
      table_training: {
        type: Array,
        default: []
      },
      table_match: {
        type: Array,
        default: []
      }
    }
  }

</script>

<style lang="scss" scoped>
.element-wrapper {
  position: relative;
  display: inline-block;
  // background-color: #05bdff;
  background-image: linear-gradient(
    to right,
    darken(#05bdff, 10%),
    darken(#05bdff, 20%)
  );
  color: white;
  max-width: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: center;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-bottom: 2.1rem;

  & i {
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    transform: translate(0%, 0);
    font-size: 10rem;
    opacity: 0.2;
    // display: none;
  }

  & .text-utils {
    position: relative;
    display: block;
    z-index: 1;
    background-color: transparent;
    width: 100%;
    height: 100%;
    text-rendering: optimizeLegibility;
  }

  & .title-bg {
    position: relative;
    display: block;
    box-sizing: border-box;
    background-color: white;
    padding: 5px 20px 1px 20px;
    margin-top: 5px;
    width: 100%;
  }
  & h3 {
    //     // display: table-cell;
    display: block;
    background-image: linear-gradient(
      to right,
      darken(#05bdff, 10%),
      darken(#05bdff, 20%)
    ); // #05bdff;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    background-color: white;
    font-size: 1.5rem;
    padding: 0;
    filter: drop-shadow(0px 1px 1px #333);
  }

  // table, td, th {
  //   border: 1px solid black;
  // }

  table {
    border-collapse: collapse;
    width: 100%;
    table-layout: auto;
  }

  tr {
    margin-top: 5px;
    margin-bottom: 5px;
    &:not(:last-child) {
      border-bottom: 1px solid rgba(white, 0.1);
    }

    & th {
      margin-top: 10px;
    }
  }

  th {
    text-align: center;
  }

  td {
    text-align: center;
    width: 33.333%
  }
}

.h-spacer {
  &.ma10 {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  &.ma20 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  &.ma30 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  &.ma40 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/demo/EquipeTrainingTest.vue